(function () {
  const SELECT_DATE_LABEL = "Select A Date";
  const ADD_TO_CART_LABEL = "Add To Cart";

  function isProductPage() {
    return document.body.classList.contains("body-template-product");
  }

  function getInfo() {
    return document.querySelector(".kg-product__info-wrapper");
  }

  function setButtonText(submit, text) {
    const label =
      submit.querySelector(".button__label") || submit.querySelector("span");
    if (label) label.textContent = text;
  }

  function applyUnselected(info) {
    info.classList.remove("kg-date-selected");
    const submit = info.querySelector('[name="add"]');
    if (!submit) return;
    submit.setAttribute("disabled", "disabled");
    submit.setAttribute("aria-disabled", "true");
    setButtonText(submit, SELECT_DATE_LABEL);
  }

  function syncDropdownLabel(info) {
    const span = info.querySelector(
      ".dropdown-select .select-wrapper > .select-label span",
    );
    const checked = info.querySelector(".dropdown-select ul li input:checked");
    if (!span || !checked) return;

    const li = checked.closest("li");
    const labelSpan = li
      ? li.querySelector("label .select-label, label span")
      : null;
    const text = (
      checked.value ||
      (li && li.getAttribute("data-value")) ||
      (labelSpan && labelSpan.textContent) ||
      ""
    ).trim();

    if (text) {
      span.textContent = text;
      span.setAttribute("title", text);
    }
  }

  function applySelected(info) {
    info.classList.add("kg-date-selected");
    syncDropdownLabel(info);
    const submit = info.querySelector('[name="add"]');
    if (!submit) return;
    submit.removeAttribute("disabled");
    submit.removeAttribute("aria-disabled");
    setButtonText(submit, ADD_TO_CART_LABEL);
  }

  function onPickDate(event, info) {
    let target = event.target;
    if (target && target.nodeType === Node.TEXT_NODE) {
      target = target.parentElement;
    }
    if (!target || typeof target.closest !== "function") return;
    const item = target.closest(".dropdown-select ul li");
    if (!item || !info.contains(item)) return;
    const input = item.querySelector("input");
    if (input && input.classList.contains("disabled")) return;
    applySelected(info);
  }

  function hasDateVariants(info) {
    return (
      !info.classList.contains("kg-no-variants") &&
      Boolean(info.querySelector(".dropdown-select"))
    );
  }

  function init() {
    if (!isProductPage()) return;
    const info = getInfo();
    if (!info || info.dataset.kgDatesInit === "true") return;
    info.dataset.kgDatesInit = "true";

    if (!hasDateVariants(info)) return;

    const hasVariantParam = new URLSearchParams(window.location.search).has(
      "variant",
    );
    if (hasVariantParam) {
      applySelected(info);
    } else {
      applyUnselected(info);
    }

    // click alone is unreliable on iOS for already-checked radios / labels
    info.addEventListener("click", function (event) {
      onPickDate(event, info);
    });
    info.addEventListener(
      "touchend",
      function (event) {
        onPickDate(event, info);
      },
      { passive: true },
    );
    info.addEventListener("change", function (event) {
      if (event.target && event.target.closest(".dropdown-select")) {
        applySelected(info);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function () {
    const info = getInfo();
    if (info) delete info.dataset.kgDatesInit;
    init();
  });
})();
